import { cn } from '@/lib/utils';

interface LogoProps {
  /** The editor top bar runs a size smaller than the marketing header. */
  compact?: boolean;
  className?: string;
}

/**
 * Brand mark + wordmark, per §7.
 *
 * The mark is the existing `/assets/images/logo.svg` asset — swapping the artwork is a change to
 * that file, not to any component. The wordmark uses a non-breaking hyphen so `editar-pdf` never
 * splits across a line.
 */
const Logo = ({ compact = false, className }: LogoProps) => (
  <span className={cn('flex items-center gap-2.5 text-ink', className)}>
    <img
      src="/assets/images/logo.svg"
      alt=""
      aria-hidden
      width={compact ? 20 : 24}
      height={compact ? 20 : 24}
      className="shrink-0"
    />
    <span className={cn('font-bold tracking-[-0.04em]', compact ? 'text-[16px]' : 'text-[19px]')}>editar{'‑'}pdf</span>
  </span>
);

export { Logo };
